import { useIntl } from 'react-intl';
import { useState } from 'react';
import RichTextInput from 'ui/Input/ReactQuillInput';
import { Flex, Form } from 'antd';
import { AuthenticationTabStyle } from './style';
import useQueryApiClient from '../../../../../utils/useQueryApiClient';
import { Button } from '../../../../../ui';

const AuthenticationTab = () => {
  const intl = useIntl();
  const [classifierIdToEdit, setClassifierIdToEdit] = useState<number>();
  const [form] = Form.useForm();

  useQueryApiClient({
    request: {
      url: `/api/v2/classifiers`,
      data: {
        page: 1,
        page_size: 1,
        filter: {
          type: 'AUTHENTICATION',
        },
      },
    },
    onSuccess: (response) => {
      setClassifierIdToEdit(response['data'][0].id);
      form.setFieldValue('classifier_value', response['data'][0].value);
    },
  });

  const { isLoading: isClassifierSaving, appendData: saveClassifier } =
    useQueryApiClient({
      request: {
        url: `/api/v2/classifiers/${classifierIdToEdit}`,
        method: 'PATCH',
      },
    });

  return (
    <AuthenticationTabStyle>
      <Form form={form}>
        <RichTextInput name={'classifier_value'} noStyle />
      </Form>
      <Flex justify={'end'}>
        <Button
          type="primary"
          label={intl.formatMessage({ id: 'general.save' })}
          onClick={() =>
            saveClassifier({
              code: 'AUTHENTICATION',
              value: form.getFieldValue('classifier_value'),
            })
          }
          loading={isClassifierSaving}
        />
      </Flex>
    </AuthenticationTabStyle>
  );
};

export default AuthenticationTab;
